import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import { MAX_KNOWN_REVIEW_COUNT } from '../constants';
import styles from './ReviewSearchCount.module.scss';

type ReviewsSearchCountProps = {
  count: number;
  hasFilters: boolean;
  hasSearch: boolean;
  query?: string;
};

const ReviewsSearchCount = ({ count, hasFilters, hasSearch, query }: ReviewsSearchCountProps) => {
  const hasAdditionalReviews = count > MAX_KNOWN_REVIEW_COUNT;
  return (
    <Typography className={styles.countContainer} component="div" variant="text200bold">
      {hasSearch &&
        (hasAdditionalReviews ? (
          <FormattedMessage defaultMessage="{count}+ reviews mention “{term}”" values={{ count: MAX_KNOWN_REVIEW_COUNT, term: query }} />
        ) : (
          <FormattedMessage
            defaultMessage="{count} {count, plural, zero {reviews mention} one {review mentions} other {reviews mention}} “{term}”"
            values={{ count, term: query }}
          />
        ))}
      {!hasSearch &&
        hasFilters &&
        (hasAdditionalReviews ? (
          <FormattedMessage defaultMessage="{count}+ {count, plural, one {review} other {reviews}}" values={{ count: MAX_KNOWN_REVIEW_COUNT }} />
        ) : (
          <FormattedMessage defaultMessage="{count} {count, plural, one {review} other {reviews}}" values={{ count }} />
        ))}
    </Typography>
  );
};

export default ReviewsSearchCount;
